import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import StatLabel from '../atoms/stat/StatLabel';
import StatValue from '../atoms/stat/StatValue';
import StatChangedAmount from '../atoms/stat/StatChangedAmount';
import Flex from '../atoms/Flex';
import StatFullValue from '../atoms/stat/StatFullValue';
import { readableNumber, readableNumberParts } from '../../helpers/Numbers';
import { color } from '../templates/Ui';
const StyledStat = styled.div `
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-bottom: 10px;
    margin-bottom: 5px;
    border-bottom: 1px solid #f1f2f2;
    min-width: 166px;

    @media only screen and (min-width: 1510px) {
        min-width: 220px;
    }

    &:last-child {
        border: none;
        padding: 0;
        margin: 0;
    }

    @media only screen and (min-width: 992px) {
        padding: 0;
        margin: 0;
        border: none;
        width: auto;
    }
`;
const Text = styled.span `
    display: block;
    margin-top: 5px;
    color: ${color.gray.darkest};
    font-size: 15px;
    font-weight: 300;
`;
const StyledFlex = styled(Flex) `
    position: relative;
    flex-direction: ${props => (props.reverse ? 'row-reverse' : 'row')};
    justify-content: space-between;
    align-items: center;

    &:first-child {
        margin-bottom: 5px;
    }

    @media only screen and (min-width: 992px) {
        flex-direction: column;
        align-items: normal;
    }
`;
const Stat = ({ label, value: inputValue, difference: inputDifference, differenceDays, isMoney = false, hasDivider, }) => {
    const { value, order, long } = readableNumberParts(inputValue, isMoney ? 'EUR' : undefined);
    const difference = inputDifference &&
        readableNumber(inputDifference, isMoney ? 'EUR' : undefined);
    const differencePrefix = inputDifference && inputDifference > 0 ? '+' : '';
    return (_jsx(_Fragment, { children: _jsxs(StyledStat, { children: [_jsxs(StyledFlex, { children: [_jsx(StatLabel, { children: label }), _jsxs(StatValue, { hasDivider: hasDivider, hasAdjacentLabel: long !== value, children: [value, " ", order && _jsx("span", { children: order })] }), long !== value && _jsx(StatFullValue, { children: long })] }), _jsx(StyledFlex, { reverse: true, children: (inputDifference || 0) !== 0 && (_jsxs(_Fragment, { children: [_jsxs(StatChangedAmount, { children: [differencePrefix, " ", difference] }), (differenceDays || 0) > 0 && (_jsx(Text, { children: differenceDays === 365
                                    ? 'in het afgelopen jaar'
                                    : `in de afgelopen ${differenceDays} dagen` }))] })) })] }) }));
};
export default Stat;
